import React from 'react';
import { iconsEnabled } from '../Helpers/iconHelper';

// A section of a form in a window, as in the invoice editor of the automatic invoicing setup: a head with an icon,
// a title and a short hint, then the fields. Fields use the design-system .field (a small capitals label over its
// control); several go side by side in a <div className='fsec-fields'>, and a small note under them in
// <div className='fsec-note'>. The icon only decorates, so it follows the "I like icons" setting.
export default function FormSection({ iconName = null, title = '', hint = null, children = null }) {
  return (
    <section className='fsec'>
      <div className='fsec-head'>
        {iconName && iconsEnabled() && (
          <span className='fsec-icon'>
            <i
              className={iconName}
              aria-hidden='true'
            />
          </span>
        )}
        <h4 className='fsec-title'>{title}</h4>
        {hint && <span className='fsec-hint'>{hint}</span>}
      </div>
      <div className='fsec-body'>{children}</div>
    </section>
  );
}
